<template>
  <el-row class="header_layout" type="flex" :justify="justify_position()" :span="24">
    <!-- logo -->
      <el-col :md="6" :sm="4" :lg="4" :xl="4" class="header_logo header_padding desktop_menu">
        <div class="grid-content bg-purple">
          <router-link class="cursor menu_text" to="/">
            <el-image :src="whichWebFunction()"  style="height: 50px"></el-image>
          </router-link>
        </div>
      </el-col>
    <!-- drawer -->
    <el-col :xs="2" :sm="1" :md="1" :lg="1" :xl="1" :offset="1" class="drawer_menu">
      <el-button type="text" @click="openDrawerMenu()"><i class="el-icon-menu "></i>
      </el-button>
    </el-col>
    <!-- menu -->
    <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14"  class="desktop_menu">
      <div class="flr">
        <router-link class="cursor menu_text" to="/">
          <el-button type="text" class="menu_text">{{ $t('home') }}</el-button>
        </router-link>
        <router-link class="cursor menu_text" to="/products">
          <el-button type="text" class="m-l-50 menu_text">{{ $t('product') }}</el-button>
        </router-link>
        <router-link class="cursor menu_text m-l-50" to="/login" v-if="this.idTokenGetter == null">
            <span class="menu_text cursor">{{ $t('login') }}</span>
          </router-link>
        <router-link class="cursor menu_text m-l-40" to="/register" v-if="this.idTokenGetter == null">
          <el-button class="white_text thin_text signup_button">{{ $t('register') }}</el-button>
        </router-link>
        <router-link class="cursor menu_text" to="/profile" v-if="this.idTokenGetter">
          <el-button class="white_text thin_text profile_button" icon="el-icon-user-solid"></el-button>
        </router-link>
        <!-- <router-link class="cursor menu_text" to="/contact">
          <el-button type="text" class="m-l-50 menu_text">{{ $t('contact') }}</el-button>
        </router-link> -->
        <!-- <router-link class="cursor menu_text" to="/">
          <el-button type="text" class="m-l-50 menu_text">{{ $t('company') }}</el-button>
        </router-link> -->
      </div>
    </el-col>
    <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2" :offset="offsetResponsive()">
    <el-badge :value="basketItemsGetterCount" class="item m-l-35">
      <router-link class="cursor p-l-50 menu_text" to="/basket">
        <i class="el-icon-goods basket_icon"></i>
      </router-link>
    </el-badge>
    </el-col>
    <!-- lang -->
    <el-col :xs="7" :sm="1" :md="1" :lg="1" :xl="1" class="m-l-25">
      <div class="flag-button-container" v-if="this.$i18n.locale === 'mn'">
        <button class="flag-button" @click="changeLanguage('en')">
          <div class="flag-icon_eng"></div>
        </button>
      </div>
      <div class="flag-button-container" v-if="this.$i18n.locale === 'en'">
        <button class="flag-button" @click="changeLanguage('mn')">
          <div class="flag-icon_mgl"></div>
        </button>
      </div>
    </el-col>
    <el-drawer title="Меню" :visible.sync="drawerMenuStatus" direction="rtl" :size="200"
      :before-close="handleCloseDrawer">
      <div>
        <el-menu :default-active="activeIndex" mode="horizontal">
          <el-menu-item index="2">
            <router-link class="cursor menu_text" to="/">
              <i class="el-icon-s-home"></i>
              <span>{{ $t('home') }}</span>
          </router-link>
          </el-menu-item>
          <el-menu-item index="3">
            <router-link class="cursor menu_text" to="/products">
              <i class="el-icon-s-goods"></i>
              <span>{{ $t('product') }}</span>
          </router-link>
          </el-menu-item>
          <!-- <el-menu-item index="4">
            <router-link class="cursor menu_text" to="/contact">
              <i class="el-icon-phone"></i>
              <span>{{ $t('contact') }}</span>
          </router-link>
          </el-menu-item> -->
          <!-- <el-menu-item index="5">
            <router-link class="cursor menu_text" to="/">
              <i class="el-icon-s-home"></i>
              <span> {{ $t('company') }}
              </span>
          </router-link>
          </el-menu-item> -->
          <el-menu-item index="6" v-if="this.idTokenGetter == null">
            <router-link class="cursor menu_text" to="/login">
              <i class="el-icon-user-solid"></i>
              <span>{{ $t('login') }} </span>
          </router-link>
          </el-menu-item>
          <el-menu-item index="7"  v-if="this.idTokenGetter == null">
            <router-link class="cursor menu_text" to="/register">
              <i class="el-icon-success"></i>
              <span>БҮРТГҮҮЛЭХ</span>
          </router-link>
          </el-menu-item>
          <router-link class="cursor menu_text" to="/profile" v-if="this.idTokenGetter">
            <i class="el-icon-s-goods"></i>
            <span>Миний бүртгэл</span>
          </router-link>
        </el-menu>
      </div>
    </el-drawer>
  </el-row>
</template>
<script>
import IteeverLogo from '@/assets/iteever_logo_hondlon.png'
import EruulhunLogo from '@/assets/logo_eruulhun1.png'
import {
  mapGetters
} from 'vuex'
export default {
  name: 'HeaderPage',
  computed: {
    ...mapGetters([
      'basketItemsGetterCount',
      'idTokenGetter'
    ])
  },
  data: function () {
    return {
      iteever_logo: IteeverLogo,
      eruulhun_logo: EruulhunLogo,
      activeIndex: '1',
      drawerMenuStatus: false,
      windowWidth: window.innerWidth
    }
  },
  created () {
  },
  methods: {
    offsetResponsive () {
      if (this.windowWidth > 900) {
        return 0
      } else {
        return 14
      }
    },
    justify_position () {
      if (this.windowWidth > 900) {
        return 'center'
      } else {
        return 'space-around'
      }
    },
    changeLanguage (lang) {
      this.$i18n.locale = lang
    },
    goToPage () {
      this.$router.push('/products')
    },
    goToHome () {
      this.$router.push({
        path: '/'
      })
    },
    goToLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    goToRegister () {
      this.$router.push({
        path: '/register'
      })
    },
    handleCloseDrawer () {
      this.drawerMenuStatus = false
    },
    openDrawerMenu () {
      this.drawerMenuStatus = true
    },
    goToBackset () {
      this.$router.push({
        path: '/basket'
      })
    },
    goToContact () {
      this.$router.push({
        path: '/contact'
      })
    },
    whichWebFunction () {
      console.log(window.location.hostname)
      if (window.location.hostname === 'www.iteever.mn') {
        return IteeverLogo
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return EruulhunLogo
      } else if (window.location.hostname === 'localhost') {
        return EruulhunLogo
      }
    }
  }
}

</script>
<style>
  @media all and (max-width: 991px) {
    .desktop_menu {
      display: none;
    }
  }

  @media all and (min-width: 991px) {
    .drawer_menu {
      display: none;
      text-align: left;
    }
  }

  @media all and (max-width: 991px) {
    .header_logo {
      display: none;
      /* padding: 50px; */
    }
  }

  @media all and (min-width: 991px) {
    .header_padding {
      padding: 50px;
    }
  }

</style>
